import { render, staticRenderFns } from "./authorityApplyList.vue?vue&type=template&id=44825ebb&scoped=true"
import script from "./authorityApplyList.vue?vue&type=script&lang=js"
export * from "./authorityApplyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44825ebb",
  null
  
)

export default component.exports